import { DB_NAME_INPUT, defineTable } from '@/duckdb';
import {
    competitorMediaInvestmentTableColumnsMap,
    competitorMediaInvestmentTableSchema,
} from './schema';

export { competitorMediaInvestmentQueries } from './queries';
export const CompetitorMediaInvestmentTable = defineTable(
    'Competitor Media Investment',
    competitorMediaInvestmentTableSchema,
    competitorMediaInvestmentTableColumnsMap,
    DB_NAME_INPUT,
);
